import React from "react";

const GxpBadge = ({ code }) => {
  if (!code) return null;
  return (
    <span
      className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border bg-slate-50 text-slate-700 border-slate-200"
      aria-label={`GxP category ${code}`}
    >
      {code.toUpperCase()}
    </span>
  );
};

export default GxpBadge;
